// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as BookOpenADefault } from '../../../assets/icons/default/education/book-open-a.svg?react';
import { ReactComponent as BookOpenASolid } from '../../../assets/icons/solid/education/BOOK-OPEN-A.svg?react';
import { createIcons } from '../../Icon';
const BookOpenAIcon = /* @__PURE__ */ createIcons('BookOpenA', {
    default: BookOpenADefault,
    solid: BookOpenASolid
});
BookOpenAIcon.supportedTypes = ['default', 'solid'];
BookOpenAIcon.category = 'education';
export default BookOpenAIcon;
